module.exports = __webpack_public_path__ + "img/mastercard.f1ad0328.svg";